module.exports = [
  ["TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t","USDT","Tether USD","TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t",6,,,true],
  ["TLa2f6VPqDgRE67v1736s7bJ8Ray5wYjU7","WIN","WINK","TLa2f6VPqDgRE67v1736s7bJ8Ray5wYjU7",6],
  ["TCFLL5dx5ZJdKnWuesXxi1VPwjLVmWZZy9","JST","JUST GOV","TCFLL5dx5ZJdKnWuesXxi1VPwjLVmWZZy9",18],
  ["TMwFHYXLJaRUPeW6421aqXL4ZEzPRFGkGT","USDJ","JUST Stablecoin","TMwFHYXLJaRUPeW6421aqXL4ZEzPRFGkGT",18],
  ["TVj7RNVHy6thbM7BWdSe9G6gXwKhjhdNZS","KLV","Klever","TVj7RNVHy6thbM7BWdSe9G6gXwKhjhdNZS",6],
  ["TBwoSTyywvLrgjSgaatxrBhxt3DGpVuENh","SEED","SEED","TBwoSTyywvLrgjSgaatxrBhxt3DGpVuENh",6],
  ["TZJmk51TP3YEETw7phRP581A7H3VzLDFsa","TEUR","EUR AlteWay Token","TZJmk51TP3YEETw7phRP581A7H3VzLDFsa",4],
  ["TAFjULxiVgT4qWk6UZwjqwZXTSaGaqnVp4","BTT","BitTorrent","TAFjULxiVgT4qWk6UZwjqwZXTSaGaqnVp4",18]  
];
